// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tv-alert-banner {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
  padding: var(--spacing-md) var(--spacing-xl);
  background: linear-gradient(90deg, rgba(239, 68, 68, 0.2), rgba(239, 68, 68, 0.1));
  border-bottom: 2px solid var(--accent-red);
  animation: alertPulse 3s ease-in-out infinite;
  overflow: hidden;
}

@keyframes alertPulse {
  0%, 100% { 
    background: linear-gradient(90deg, rgba(239, 68, 68, 0.2), rgba(239, 68, 68, 0.1));
  }
  50% { 
    background: linear-gradient(90deg, rgba(239, 68, 68, 0.3), rgba(239, 68, 68, 0.15));
  }
}

.tv-alert-icon {
  position: relative;
  color: var(--accent-red);
  flex-shrink: 0;
  animation: alertIconPulse 1s ease-in-out infinite;
}

@keyframes alertIconPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.alert-count {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  background: var(--accent-red);
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tv-alert-content {
  flex: 1 1;
  overflow: hidden;
}

.tv-alert-marquee {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
  animation: marquee 30s linear infinite;
  white-space: nowrap;
}

@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.tv-alert-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.severity-badge {
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
}

.severity-badge.extreme {
  background: var(--accent-red);
  color: white;
}

.severity-badge.severe {
  background: var(--accent-orange);
  color: white;
}

.severity-badge.moderate {
  background: var(--accent-yellow);
  color: black;
}

.severity-badge.minor {
  background: var(--accent-blue);
  color: white;
}

.alert-event {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-primary);
}

.alert-headline {
  font-size: 1rem;
  color: var(--text-secondary);
}

.alert-divider {
  color: var(--text-muted);
  margin: 0 var(--spacing-md);
}`, "",{"version":3,"sources":["webpack://./src/components/TV/TVAlertBanner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,kFAAkF;EAClF,0CAA0C;EAC1C,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE;IACE,kFAAkF;EACpF;EACA;IACE,mFAAmF;EACrF;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B","sourcesContent":[".tv-alert-banner {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-lg);\n  padding: var(--spacing-md) var(--spacing-xl);\n  background: linear-gradient(90deg, rgba(239, 68, 68, 0.2), rgba(239, 68, 68, 0.1));\n  border-bottom: 2px solid var(--accent-red);\n  animation: alertPulse 3s ease-in-out infinite;\n  overflow: hidden;\n}\n\n@keyframes alertPulse {\n  0%, 100% { \n    background: linear-gradient(90deg, rgba(239, 68, 68, 0.2), rgba(239, 68, 68, 0.1));\n  }\n  50% { \n    background: linear-gradient(90deg, rgba(239, 68, 68, 0.3), rgba(239, 68, 68, 0.15));\n  }\n}\n\n.tv-alert-icon {\n  position: relative;\n  color: var(--accent-red);\n  flex-shrink: 0;\n  animation: alertIconPulse 1s ease-in-out infinite;\n}\n\n@keyframes alertIconPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n.alert-count {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: 22px;\n  height: 22px;\n  background: var(--accent-red);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 700;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tv-alert-content {\n  flex: 1;\n  overflow: hidden;\n}\n\n.tv-alert-marquee {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-lg);\n  animation: marquee 30s linear infinite;\n  white-space: nowrap;\n}\n\n@keyframes marquee {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n\n.tv-alert-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.severity-badge {\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.severity-badge.extreme {\n  background: var(--accent-red);\n  color: white;\n}\n\n.severity-badge.severe {\n  background: var(--accent-orange);\n  color: white;\n}\n\n.severity-badge.moderate {\n  background: var(--accent-yellow);\n  color: black;\n}\n\n.severity-badge.minor {\n  background: var(--accent-blue);\n  color: white;\n}\n\n.alert-event {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.alert-headline {\n  font-size: 1rem;\n  color: var(--text-secondary);\n}\n\n.alert-divider {\n  color: var(--text-muted);\n  margin: 0 var(--spacing-md);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
